import { useState } from 'react';
import './scss/Header.scss';

function Header() {

  const [menuIsOpen, setMenuIsOpen] = useState(0);

  function toggleMenu() {
    setMenuIsOpen(!menuIsOpen)
  }

  return(
    <header id="top">
      <div id="title-menu-container">
        <h4>Lettuce Celebrate!</h4>
        <button className="icon" id="main-menu-button" onClick={toggleMenu}></button>
      </div>
      {menuIsOpen ? 
        <menu>
          <input placeholder="Search recipes" type="text" id="search"></input>
          <nav>
            <ul>
              <li>Home</li>
              <li>All recipes</li>
              <li>About</li>
            </ul>
          </nav>
          
        </menu>
      : null }
    </header>
  )
}

export default Header;